import React from 'react';
import { parseUpdateParagraph } from '../../utils/parseUpdateParagraph.js';
import { useAppSelector } from '../../utils/storeHooks.js';

const UpdatesPage = () => {

    const {lang} = useAppSelector(store => store.display)

    const pageContent = [
        {
            _id: new Date() + "",
            en: {
                title: 'Thursday 7th May, 2026',
                tahi: 'Tēnā koutou o Papatūānuku whānui! {{ml-1 text-sm|(little programmer&apos;s mihi there for you.)}}',
                rua: 'Today is the first public outing for Tukutuku. We have been keeping this entirely quiet while we work, but today it is a secret no longer. We will be presenting this concept at Te Mātoe o te Reo in Ngā Motu, and, of course, this placeholder site is up for you to see now!',
                toru: 'We&apos;re happy to finally breathe some fresh air, and are looking forward to sharing more about our progress in the coming months.',
                wha: 'In the meantime - have a look at our [about](/about) page to learn more about Tukutuku.',
                off: 'Mouri ora rā e te whānau,',
                rima: 'Maikara Gaastra (lead developer)'
            },
            ma: {
                title: 'Tāite 7 Mei, 2026',
                tahi: 'Tēnā koutou o Papatūānuku whānui! {{ml-1 text-sm|(nā he paku mihi ā-ringahiko māu)}}',
                rua: 'Ko tēnei te rangi tuatahi e puta ai te kōrero mō Tukutuku. Kua muna mārika tā tātou mahi engari, ināianei, kua rite ki te whāki atu i te kaupapa. Ka kōrerohia i tēnei rā ki Te Mātoe o te Reo kei Ngā Motu (ā, kua tū ngā whārangi torutoru nei hei waharoa mō te hunga e tatari ana ki te karanga).',
                toru: 'E koa ana mātou i tēnei kaupeka hou o te haerenga whakariterite i a Tukutuku. E hīkaka hoki ana ki te whakawhānui atu i te kōrero i ngā marama e tū mai ana.',
                wha: 'Heoi, mō tēnei wā, tēnā, tirohia te whārangi ["mō Tukutuku"](/about) kia hīnātore mai te māramatanga mō tēnei mea, a Tukutuku.',
                off: 'Mouri ora rā e te whānau,',
                rima: 'Maikara Gaastra (lead developer)'
            }
        }
    ]

    return (
        <div className=' bodyHeight readMat px-4 md:mx-auto md:px-24 md:max-w-248'>
        {
            pageContent.map((obj) => {
                const { _id } = obj
                return (
                    <div key={_id} className='pt-4 md:pt-8'>
                        {
                            Object.entries(obj[lang]).map(([key, line]) => {
                                switch (key) {
                                    case('title'): {
                                        return <h2 key={_id+'_'+key} className='mb-2 font-light'>{line}</h2>
                                    }
                                    case ('off'): {
                                        return <p key={_id+'_'+key} className='paragraph mb-0 pb-0'>{line}</p>
                                    }
                                    default: {

                                        const uniqueChars = new Set(line);
                                        const subKey = _id+'_'+key;

                                        if (uniqueChars.has('[') || uniqueChars.has('{')){
                                            return parseUpdateParagraph(line, subKey)
                                        }
                                        return <p key={subKey} className='paragraph'>{line}</p>

                                    }
                                }
                            })
                        }
                    </div>
                )
            })
        }
        </div>
    )
};

export default UpdatesPage